<header class="header-style2 site-header mobile-sider-drawer-menu full-navbar">

    <div class="sticky-header main-bar-wraper navbar-expand-lg">
        <div class="main-bar">

            <div class="container clearfix">
                <div class="logo-header">
                    <div class="logo-header-inner logo-header-one">
                        <a routerLink="/index">
                            <img src="assets/images/Logo-light.png" alt="#">
                        </a>
                    </div>
                </div>
                <!-- NAV Toggle Button -->
                <button id="mobile-side-drawer" data-target=".header-nav" data-toggle="collapse" type="button"
                    class="navbar-toggler collapsed">
                    <span class="sr-only">Toggle navigation</span>
                    <span class="icon-bar icon-bar-first"></span>
                    <span class="icon-bar icon-bar-two"></span>
                    <span class="icon-bar icon-bar-three"></span>
                </button>

                <!-- EXTRA NAV -->
                <div class="extra-nav">

                    <div class="extra-cell">
                        <app-search-trigger></app-search-trigger>
                    </div>

                    <div class="extra-cell">
                        <app-lang-switch></app-lang-switch>
                    </div>

                    <div class="extra-cell">
                        <ul class="list-unstyled social-bx d-flex flex-wrap align-content-center text-white ">
                            <li *ngIf="info.social('facebook')"><a [href]="info.social('facebook')" target="_blank" rel="noopener"><i class="feather-facebook"></i></a></li>
                            <li *ngIf="info.social('twitter')"><a [href]="info.social('twitter')" target="_blank" rel="noopener"><i class="feather-twitter"></i></a></li>
                            <li *ngIf="info.social('linkedin')"><a [href]="info.social('linkedin')" target="_blank" rel="noopener"><i class="feather-linkedin"></i></a></li>
                            <li *ngIf="info.social('instagram')"><a [href]="info.social('instagram')" target="_blank" rel="noopener"><i class="feather-instagram"></i></a></li>
                        </ul>
                    </div>

                    <div class="extra-cell">

                        <div class="sx-topbar-left">
                            <ul class="e-p-bx">
                                <li><a [href]="'mailto:' + info.email('contactus@maven-merge.com')">{{ info.email('contactus@maven-merge.com') }}</a></li>
                                <li><a [href]="'tel:' + info.phone('+201026691116')">{{ info.phone('+20 102 669 1116') }}</a></li>
                            </ul>
                        </div>
                    </div>



                </div>
                <!-- EXTRA Nav -->

                <!-- MAIN NAVIGATION -->
                <div class="header-nav navbar-collapse collapse d-flex justify-content-center collapse ">
                    <ul class=" nav navbar-nav ">
                        <li class="active">
                            <a routerLink="/index" >Home</a>
                            <!-- <ul class="sub-menu">
                                <li><a routerLink="/index">Home-1</a></li>
                                <li><a routerLink="/index2">Home-2</a></li>
                                <li><a routerLink="/index3">Home-3</a></li>
                            </ul> -->
                        </li>

                        <li>
                            <a href="javascript:;">Company</a>
                            <ul class="sub-menu">
                                <li><a routerLink="/company/about">About Us</a></li>
                                <li><a routerLink="/company/faq">Faq Page</a></li>
                                <li><a routerLink="/company/gallery">Gallery</a></li>
                                <li><a routerLink="/company/careers">Careers</a></li>
                                <li><a routerLink="/company/offers">Offers</a></li>
                                <!-- <li><a routerLink="/company/icons">Icons</a></li> -->
                                <li><a routerLink="/company/testimonials">Testimonials</a></li>
                                <!-- <li><a routerLink="/company/why-choose-us">Why Choose Us</a></li> -->
                                <!-- <li><a routerLink="/company/pricing">Pricing</a></li> -->
                                <!-- <li><a routerLink="/company/team">Team</a></li> -->
                            </ul>
                        </li>

                        <li>
                            <a href="javascript:;">IT Solutions</a>
                            <ul class="sub-menu">
                                <li><a routerLink="/itsolutions/mission">Mission & Vision</a></li>
                                <li><a routerLink="/itsolutions/services">Services</a></li>
                                <!-- <li><a routerLink="/itsolutions/services/detail">Services Detail</a></li> -->
                                <!-- <li><a routerLink="/itsolutions/portfolio/1">Portfolio</a></li>
                                <li><a routerLink="/itsolutions/portfolio/2">Portfolio-2</a></li> -->
                                <!-- <li><a routerLink="/itsolutions/portfolio/detail">Portfolio Detail</a></li> -->
                            </ul>
                        </li>
<!-- 
                        <li>
                            <a href="javascript:;">IT Blogs</a>
                            <ul class="sub-menu">
                                <li><a routerLink="/itblogs/blogs/grid">Blog</a></li>
                                <li><a routerLink="/itblogs/blogs/list-sidebar">Blog Grid Sidebar </a></li>
                                <li><a routerLink="/itblogs/blogs/detail-sidebar">Blog Detail Sidebar</a></li>
                                <li><a routerLink="/itblogs/blogs/detail">Blog Detail</a></li>
                            </ul>
                        </li> -->

                        <li><a routerLink="/itblogs/blogs/grid">News</a></li>

                        <li><a routerLink="/company/contact">Contact Us</a></li>

                    </ul>
                </div>


            </div>

        </div>
    </div>
</header>